import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { STUDIO_ACCESS_TIER } from 'Pods/ThreeDStudio/Store/constants'

// See useDccBridgeAccess. Export has no server-side counterpart, so this hook is the only gate.
// Unlike the DCC bridge and private mode, an active free trial can export: letting trial users
// download what they generated is what lets them evaluate the output.
function useExportAccess() {
  const premiumFeatures = useThreeDStudioStore((state) => state.subscription.premiumFeatures)
  const studioAccessTier = useThreeDStudioStore((state) => state.subscription.studioAccessTier)
  return premiumFeatures === true || studioAccessTier === STUDIO_ACCESS_TIER.IN_FREE_BETA
}

export default useExportAccess
